import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap'
};

const IconText = ({ className, iconType, text, iconColor, ...props }) => (
  <div className='col-xs-12' {...props}>
    <span className={`row ${className}`} style={{ ...styles }}>
      {iconType && (
        <i className={`nyc-icon ${iconType}`} style={{ color: iconColor }} />
      )}
      {text && <p className='pl-1x'>{text}</p>}
    </span>
  </div>
);

IconText.defaultProps = {
  className: ''
};

IconText.propTypes = {
  className: PropTypes.string,
  iconType: PropTypes.string,
  iconColor: PropTypes.string,
  text: PropTypes.string
};

export default IconText;
